import { Grid, Typography, Box } from '@mui/material';
import video from '../../../../assets/video.jpeg';
import background from '../../../../assets/webglobspot-07.png';
import CustomModal from '../CustomModal/CustomModal';
import { useState } from 'react';
import Alerts from '../Alerts/Alerts';
import Footer from '../footer/footer';

const Launch = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [alert, setAlert] = useState({ message: '', severity: 'success' as 'success' | 'error', open: false });
  const showAlert = (message: string, severity: 'success' | 'error') => {
    setAlert({ message, severity, open: true });
  };
  const handleAlertClose = () => {
    setAlert((prevAlert) => ({ ...prevAlert, open: false }));
  };
  const handleCloseModal = () => setModalOpen(false);
  
  return (
    <Box sx={{
      backgroundImage: `url(${background})`,
      backgroundSize: { xs: 'cover', md: '100% 100%' },
      backgroundPosition: 'center',
      padding: { xs: '5% 0', md: '10px' },  // Ajuste de padding en móvil
    }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: 'auto',
          padding: '10px',
          height: { xs: 'auto', md: 500 },  // Ajuste de altura para móviles
        }}
      >
        <Grid
          container
          spacing={{ xs: 2, md: 12 }} // Espaciado menor en pantallas pequeñas y mayor en grandes
          alignItems="center"
          justifyContent="center"
          sx={{
            marginTop: { xs: '2%', md: '3%' },
          }}
        >
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                maxWidth: { xs: '70%', md: '400px' },  // Reducir el tamaño máximo en móviles y 400px en pantallas medianas
                marginLeft: 'auto', // Centrado de la imagen
                marginRight: 'auto', // Centrado de la imagen
                display: 'block', // Centrado de la imagen
              }}
            >
              <img
                src={video}
                alt="Descripción de la imagen"
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '20px',
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={5} sx={{ color: 'white', textAlign: { xs: 'center', md: 'left' }, mt: { xs: 2, md: 8 } }}>
            <Typography variant="h1" sx={{ fontSize: { xs: '1.5rem', md: '3rem' }, fontWeight: 'bold' }}>
              Supervisión en video
            </Typography>
            <Typography variant="body2" sx={{ fontSize: { xs: '0.9rem', md: '1.5rem' }, mt: 2, fontWeight: 'bold' }}>
              Monitorea el comportamiento de los choferes y previene accidentes en tiempo real.
            </Typography>
            <Typography variant="body2" sx={{ fontSize: { xs: '0.9rem', md: '1.5rem' }, mt: 2 }}>
              Con la supervisión en video de Globspot, puedes detectar y corregir conductas inadecuadas para evitar incidentes y mejorar la seguridad.
            </Typography>
          </Grid>
        </Grid>
        <CustomModal
          open={isModalOpen}
          handleClose={handleCloseModal}
          showAlert={showAlert}
        />
        <Alerts 
          message={alert.message} 
          severity={alert.severity} 
          open={alert.open} 
          onClose={handleAlertClose} 
        />
      </Box>
      <Footer />
    </Box>
  );
};

export default Launch;
